import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  FormLayout,
  Card,
  TextField,
  Select,
  InlineError,
  PageActions,
  Toast,
  Loading,
  Button,
  Collapsible,
  Spinner,
  Modal,
  Text,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { validate } from "email-validator";

const AddEditUser = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [item, setItem] = useState({
    name: "",
    lastName: "",
    password: "",
    confirmPassword: "",
    email: "",
    role: "",
  });
  const optionsRoles = [{ label: "Super Admin", value: "1" }];
  const handleChangeFirstName = (newValue) => {
    setItem({ ...item, name: newValue });
    setFirstNameError("");
  };
  const handleChangeLastName = (newValue) => {
    setItem({ ...item, lastName: newValue });
    setLastNameError("");
  };
  const handleChangeEmail = (newValue) => {
    setItem({ ...item, email: newValue });
    setEmailError("");
  };
  const handleChangePassword = (newValue) => {
    setItem({ ...item, password: newValue });
    setPasswordError("");
    setPasswordsError("");
  };
  const handleChangeConfirmPassword = (newValue) => {
    setItem({ ...item, confirmPassword: newValue });
    setConfirmPasswordError("");
    setPasswordsError("");
  };
  const handleChangeRole = (newValue) => {
    setItem({ ...item, role: newValue });
    setRoleError("");
  };
  const [nameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [passwordsError, setPasswordsError] = useState("");
  const [roleError, setRoleError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  useEffect(() => {
    props.type === "edit" &&
      axios
        .get(`/management/users/${id}`)
        .then((result) => {
          setItem({
            name: result?.data?.data?.name ? result.data.data.name : "",
            // lastName: result?.data?.data?.last_name
            //   ? result.data.data.last_name
            //   : "",
            email: result?.data?.data?.email ? result.data.data.email : "",
          });
          setIsSaving(false);
        })

        .catch((err) => console.log(err));
  }, []);
  const [open, setOpen] = useState(false);
  const handleToggle = useCallback(() => setOpen((open) => !open), []);

  const refId = useRef(null);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/management/users/${id}`)
      .then((result) => {
        navigate("/admin/settings/users-and-permissions");
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} User`}
      backAction={{
        onAction: () => navigate("/admin/settings/users-and-permissions"),
      }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              label="Name"
              value={item.name}
              onChange={handleChangeFirstName}
              error={nameError}
              requiredIndicator
            />
            <TextField
              value={item.email}
              onChange={handleChangeEmail}
              error={emailError}
              label="Email"
              requiredIndicator
            />
            {/* <TextField
              value={item.lastName}
              onChange={handleChangeLastName}
              error={lastNameError}
              label="Last Name"
            /> */}
          </FormLayout.Group>

          {props.type === "add" ? (
            <FormLayout.Group>
              <TextField
                value={item.password}
                onChange={handleChangePassword}
                error={passwordError}
                label="Password"
                requiredIndicator
              />
              <TextField
                value={item.confirmPassword}
                onChange={handleChangeConfirmPassword}
                error={confirmPasswordError}
                label="Confirm Password"
                requiredIndicator
              />
            </FormLayout.Group>
          ) : (
            <FormLayout>
              <Button
                onClick={handleToggle}
                ariaExpanded={open}
                ariaControls="basic-collapsible"
                variant="primary"
              >
                Change Password
              </Button>
              <Collapsible
                open={open}
                id="basic-collapsible"
                transition={{
                  duration: "500ms",
                  timingFunction: "ease-in-out",
                }}
                expandOnPrint
              >
                <FormLayout.Group>
                  <TextField
                    value={item.password}
                    onChange={handleChangePassword}
                    error={passwordError}
                    label="Password"
                  />
                  <TextField
                    value={item.confirmPassword}
                    onChange={handleChangeConfirmPassword}
                    error={confirmPasswordError}
                    label="Confirm Password"
                  />
                </FormLayout.Group>
              </Collapsible>
            </FormLayout>
          )}

          <InlineError message={passwordsError} />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={
          <Button variant="primary" onClick={handleSave}>
            {isSaving ? <Spinner size="small" /> : "Save"}
          </Button>
        }
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              {isSaving ? <Spinner size="small" /> : "Delete"}
            </Button>
          )
        }
      />
      {/* <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(`/management/users/${id}`)
                  .then((result) => {
                    navigate("/admin/settings/users-and-permissions");
                  })
                  .catch((err) => console.log(err));
              }}
            >
              Delete
            </Button>
          )
        }
      /> */}

      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
    </Page>
  );
  function handleSave() {
    if (
      !item.name ||
      !item.email ||
      (props.type === "add" && !item.password) ||
      (props.type === "add" && !item.confirmPassword) ||
      // item.role === "" ||
      (item.email && !validate(item.email.replace(/\s/g, ""))) ||
      (props.type === "add" &&
        item.password &&
        item.confirmPassword &&
        item.password !== item.confirmPassword) ||
      (props.type === "add" && item.password.length < 8 && item.password)
    ) {
      !item.name && setFirstNameError("This field is required");
      !item.email && setEmailError("This field is required");
      props.type === "add" &&
        !item.password &&
        setPasswordError("This field is required");
      props.type === "add" &&
        !item.confirmPassword &&
        setConfirmPasswordError("This field is required");
      // item.role === "" && setRoleError("Please select a role");
      item.email &&
        !validate(item.email.replace(/\s/g, "")) &&
        setEmailError("Please use a valid email address");
      props.type === "add" &&
        item.password &&
        item.confirmPassword &&
        item.password !== item.confirmPassword &&
        setPasswordsError("Passwords do not match");
      props.type === "add" &&
        item.password.length < 8 &&
        item.password &&
        setPasswordsError("Passwords must be at least 6 characters");
    } else {
      setIsSaving(true);
      const bodyObj = {
        name: item.name,
        // last_name: item.lastName,
        email: item.email,
        is_active: 1,
        password: item.password,
        "confirm-password": item.confirmPassword,
      };
      props.type === "add"
        ? axios
            .post(`/management/users`, bodyObj)
            .then((result) => {
              navigate("/admin/settings/users-and-permissions");
            })
            .catch((error) => {
              setIsSaving(false);
              // Error
              console.log("error=", error);
              if (error.response) {
                setPasswordError(
                  <ul>
                    {error.response.data.errors.password.map(
                      (element, index) => {
                        return (
                          <div key={index}>
                            <h2>{element}</h2>
                          </div>
                        );
                      }
                    )}
                  </ul>
                );
              } else if (error.request) {
                console.log(error.request);
              } else {
                console.log("Error", error.message);
              }
              console.log(error.config);
            })
        : axios
            .patch(`/management/users/${id}`, bodyObj)
            .then((result) => {
              navigate("/admin/settings/users-and-permissions");
              // toggleActive();
              // setIsSaving(false);
            })
            .catch((error) => {
              // Error
              console.log("error=", error);
              setIsSaving(false);
              if (error.response) {
                setPasswordError(
                  <ul>
                    {error.response.data.errors.password.map(
                      (element, index) => {
                        return (
                          <div key={index}>
                            <h2>{element}</h2>
                          </div>
                        );
                      }
                    )}
                  </ul>
                );
              } else if (error.request) {
                console.log(error.request);
              } else {
                console.log("Error", error.message);
              }
              console.log(error.config);
            });
    }
  }
};

export default AddEditUser;
